import { Equipment } from "../../../../types/types";
import { MonthReport } from "./MonthReport";

export const ReportTab = ({equipment}:{equipment:Equipment}) => {
  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background">
      <MonthReport equipment={equipment}/>
    </div>
  )
};
